import * as React from 'react';

import { MetricValuePill, SparkLine } from '@tableau/metrics-shared-widgets-dom';

import { getMeasureFormat, getMetricMeasure, getTableWithDefaultComparison } from '..';
import { cssClass } from '../../style';
import { IMetricDataInfo } from '../models/IMetricInfo';
import { computeMetricComparison, DataRow, getLatestValue, MetricBlue, MetricsNeutralColor } from '@tableau/metrics-engine';
import { FeatureFlags } from '../../ts/FeatureFlags';

export type MetricSparklineAndPillProps = {
    readonly metricData: IMetricDataInfo;
    readonly timestampAccessor?: (point: DataRow) => Date | undefined;
    readonly measureAccessor: (point: DataRow) => number;
    readonly colorAccessor: (point: DataRow) => string;
};

export class MetricSparklineAndPill extends React.PureComponent<MetricSparklineAndPillProps> {
    public render(): JSX.Element {
        let measure;
        let format;

        if (this.props.metricData && this.props.metricData.dataPoints && this.props.metricData.dataPoints.length > 0) {
          measure = getMetricMeasure(this.props.metricData, this.props.measureAccessor);
          format = getMeasureFormat(this.props.metricData);
        }

        const showSparkline = this.props.metricData && this.props.metricData.dataPoints && this.props.metricData.dataPoints.length > 1 && this.props.timestampAccessor;

        const comparisonTable = this.props.metricData && getTableWithDefaultComparison(this.props.metricData);

        const latestValue = comparisonTable && getLatestValue(comparisonTable);
        const comparison = latestValue && computeMetricComparison(latestValue);

        const colorsEnabledColor =
          latestValue && comparison
            ? this.props.colorAccessor(comparison.comparedPoint)
            : MetricsNeutralColor;

        const color = FeatureFlags.metricColorIndicatorsEnabled ? colorsEnabledColor : MetricBlue;

        return (
        <div data-tb-test-id="omnibox-metric-thumbnail">
            <span className={MetricOmniPillStyle} data-tb-test-id="omnibox-metric-pill">
              <MetricValuePill value={measure} measureFormat={format} color={color} />
            </span>
            {
              showSparkline &&
              <SparkLine
                size={MetricOmniSparklineSize}
                data={this.props.metricData.dataPoints.slice(-30)}  // 100 points is still kind of slow so use only 30
                timestampAccessor={this.props.timestampAccessor}
                measureAccessor={this.props.measureAccessor}
                style={MetricOmniSparklineStyle}
                color={color}
                testId={'omnibox-metric-sparkline'}
                formatString={format}
              />
            }
            {
              !showSparkline && <div style={{...MetricOmniSparklineStyle, ...MetricOmniSparklineSize}} />
            }
        </div>);
    }
}

const thumbnailWidth = 76;
const sparklineHeight = 18;

const MetricOmniPillStyle = cssClass('omni', 'metric-pill', {
  display: 'flex',
  flexGrow: 1,
  flexDirection: 'row',
  paddingTop: 8,
  alignItems: 'center',
  justifyContent: 'center',
  width: thumbnailWidth + 'px',
  height: '20px',
});

const MetricOmniSparklineStyle = {paddingTop: '8px', paddingBottom: '8px'};
const MetricOmniSparklineSize = { width: thumbnailWidth, height: sparklineHeight};
